/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_TitleInputs */

const en_features_finance_title = /** @type {(inputs: Features_Finance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finances`)
};

const pl_features_finance_title = /** @type {(inputs: Features_Finance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanse`)
};

/**
* | output |
* | --- |
* | "Finances" |
*
* @param {Features_Finance_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_title = /** @type {((inputs?: Features_Finance_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_title(inputs)
	return en_features_finance_title(inputs)
});